/**
 * loại chứng từ
 */
export default {
  /* -----------------------------------------------------
  Cấu hình RefType load service cho button print Panda
   ------------------------------------------------------ */

  // Không phải chứng từ
  NonVoucher: 0,
  // Phiếu thu
  CashReceipt: 20,
  // Phiếu chi
  CashPayment: 21,
  // Séc
  Cheque: 40,
  // Phiếu nộp tiền vào tài khoản
  Deposit: 41,
  // Phiếu nhập kho
  InwardStock: 60,
  // Phiếu xuất kho
  OutwardStock: 61,
  // Chuyển kho nội bộ
  AssetTransfer: 62,
  // Phiếu kết chuyển tài khoản 
  AccountTransferSlipVoucher: 70,
  // Phân phối tiền thu
  JusticeReceiptAllocation: 71,
  // Phân phối tiền bán tài sản
  JusticeSellingAllocation: 72,
  // Chứng từ nghiệp vụ khác
  GeneralJournalEntry: 80,
  // Phiếu xác định tiền, giá trị TSTV
  AssetEvaluation: 98,
  // Tổng hợp chứng từ cùng loại
  VoucherList: 99,
  // Báo cáo nhanh
  // Kiểm kê tài sản, tang vật
  Inventory: 120,

  // Số dư tài khoản khác
  InitialBalanceOther: 90,
  // Số dư tài sản tang vật
  InitialBalanceAsset: 91,
  // Số dư theo đối tượng
  InitialBalanceObject: 92,
  // Số dư theo đối tượng và quyết định
  InitialBalanceObjectDecision: 93,
  // Số dư tài khoản ngân hàng
  InitialBalanceBank: 94,
  // Chuyển chấp hành viên
  TransferExecutor: 121,
  //Biên lai
  Ticket:141,
  // FPT Connect
  FptPayment: 215,
  FptPayout: 216,
  FptAdvancePayment: 217,
  FptInwardStock: 605,
  FptOutwardStock: 615,
};
